
export class TextPatternCreationDto {
  constructor(
    public id: number,
    public name: string,
    public mode: string,
    public content: string,
    public vocabCategoryIds: number[],
    public vocabEntryIds: number[],
    public functionalGrammarCategoryIds: number[],
    public functionalGrammarEntryIds: number[],
    public systemicGrammarCategoryIds: number[],
    public systemicGrammarEntryIds: number[],
    public textPatternIds: number[],
    public textTypeIds: number[],
    public detailedCanDoStatementCategoryIds: number[],
    public detailedCanDoStatementEntryIds: number[],
    public globalCanDoStatementCategoryIds: number[],
    public globalCanDoStatementEntryIds: number[]
  ) {
  }
}
